import React from "react";
import "./supportGroupsRates.scss";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

const SupportGroupRates = (props: ReferenciaContenido) => {
  const data = props;

  return (
    <div className="m-group-rates">
      <div className="m-group-rates__title">
        <h3>{data?.tituloGeneral}</h3>
      </div>
      <div className="m-group-rates__container">
        {data?.referenciaPlantillaContenido?.map((elem, idx) => {
          const elementParse = JSON.parse(elem?.descripcion?.raw);

          return (
            <div className="m-group-rates__container__rate" key={idx}>
              <div className="m-group-rates__container__rate__price">
                <p>
                  <span>
                    {elem?.descripcion?.raw &&
                      elementParse?.content[0]?.content[0]?.value}
                  </span>
                  <strong>
                    {elem?.descripcion?.raw &&
                      elementParse?.content[0]?.content[1]?.value}
                  </strong>
                  {elem?.descripcion?.raw &&
                    elementParse?.content[0]?.content[2]?.value}
                  {elem?.descripcion?.raw &&
                    elementParse?.content[0]?.content[3]?.value}
                </p>
              </div>
              <div className="m-group-rates__container__rate__info">
                <p>{elem?.tituloBanner}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SupportGroupRates;
